import { gql } from '@apollo/client';

export default gql`
  mutation createPriorities($input: CreatePrioritiesInput!) {
    createPriorities(input: $input) {
      count
    }
  }
`;
